import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CalsoftHorizontalNavigationBasicItemComponent } from './horizontal/components/basic/basic.component';
import { CalsoftHorizontalNavigationBranchItemComponent } from './horizontal/components/branch/branch.component';
import { CalsoftHorizontalNavigationDividerItemComponent } from './horizontal/components/divider/divider.component';
import { CalsoftHorizontalNavigationSpacerItemComponent } from './horizontal/components/spacer/spacer.component';
import { CalsoftVerticalNavigationAsideItemComponent } from './vertical/components/aside/aside.component';
import { CalsoftVerticalNavigationBasicItemComponent } from './vertical/components/basic/basic.component';
import { CalsoftVerticalNavigationCollapsableItemComponent } from './vertical/components/collapsable/collapsable.component';
import { CalsoftVerticalNavigationDividerItemComponent } from './vertical/components/divider/divider.component';
import { CalsoftVerticalNavigationGroupItemComponent } from './vertical/components/group/group.component';
import { CalsoftVerticalNavigationSpacerItemComponent } from './vertical/components/spacer/spacer.component';
import { CalsoftScrollbarModule } from '../../directives/scrollbar';
import { DirectiveModule } from '../../../shared/directive/directive.module';
import { CalsoftHorizontalNavigationComponent } from './horizontal/horizontal.component';
import { CalsoftVerticalNavigationComponent } from './vertical/vertical.component';

@NgModule({
  declarations: [
    CalsoftHorizontalNavigationBasicItemComponent,
    CalsoftHorizontalNavigationBranchItemComponent,
    CalsoftHorizontalNavigationDividerItemComponent,
    CalsoftHorizontalNavigationSpacerItemComponent,
    CalsoftHorizontalNavigationComponent,
    CalsoftVerticalNavigationAsideItemComponent,
    CalsoftVerticalNavigationBasicItemComponent,
    CalsoftVerticalNavigationCollapsableItemComponent,
    CalsoftVerticalNavigationDividerItemComponent,
    CalsoftVerticalNavigationGroupItemComponent,
    CalsoftVerticalNavigationSpacerItemComponent,
    CalsoftVerticalNavigationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    CalsoftScrollbarModule,
    DirectiveModule
  ],
  exports: [
    CalsoftHorizontalNavigationComponent,
    CalsoftVerticalNavigationComponent
  ]
})
export class CalsoftNavigationModule {
}
